import a, { forwardRef as z } from "react";
import { u as y } from "./chunk.CGDVNEL3.js";
import { useTheme as E, Box as b, CircularProgress as f, Typography as M } from "@mui/material";
import { g as w } from "./chunk.BurCwd5X.js";
const O = z(
  (e, s) => {
    const t = E(), i = e != null && e.id ? e.id : y("circularProgress-"), r = e.label ? `${i}-label` : void 0, v = `${i}-container`, n = e != null && e.labelOrientation ? e.labelOrientation : "left", l = e != null && e.size ? e == null ? void 0 : e.size : "md", h = n === "left" || n === "right", u = n === "left" || n === "above", o = l === "sm" || l === "md", x = o ? t.spacing(1.5) : t.spacing(2), m = o ? t.spacing(1) : t.spacing(2), g = o ? t.spacing(0.5) : t.spacing(1), C = {
      left: { pr: m },
      right: { pl: m },
      above: { pb: g },
      below: { pt: g }
    }, c = {
      sm: t.spacing(2),
      md: t.spacing(3),
      lg: t.spacing(4),
      xl: t.spacing(6)
    }, d = () => /* @__PURE__ */ a.createElement(M, { fontSize: x, sx: C[n], id: r }, e.label);
    return /* @__PURE__ */ a.createElement(
      b,
      {
        id: v,
        display: "flex",
        flexDirection: h ? "row" : "column",
        alignItems: "center",
        justifyContent: "center",
        width: "fit-content"
      },
      e.label && u ? /* @__PURE__ */ a.createElement(d, null) : null,
      /* @__PURE__ */ a.createElement(b, { sx: { position: "relative", height: c[l] } }, /* @__PURE__ */ a.createElement(
        f,
        {
          variant: "determinate",
          sx: {
            color: t.palette.grey[200]
          },
          size: c[l],
          value: 100,
          role: "none",
          "aria-valuenow": void 0
        }
      ), /* @__PURE__ */ a.createElement(
        f,
        {
          id: i,
          sx: {
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0
          },
          size: c[l],
          "aria-labelledby": r,
          "aria-label": e["aria-label"],
          variant: e.variant,
          value: e.value,
          ref: s,
          onBlur: e.onBlur,
          onFocus: e.onFocus,
          onMouseOver: e.onMouseOver,
          onMouseLeave: e.onMouseLeave,
          ...w(s)
        }
      )),
      e.label && !u ? /* @__PURE__ */ a.createElement(d, null) : null
    );
  }
);
export {
  O as C
};
